module.exports = __webpack_public_path__ + "static/paymongo_key-ac1657f03f15c31d207bb426322ddbf1.png";